module.exports = __webpack_public_path__ + "img/9788974839338.2a206aae.jpg";